import { Attributes, LookupBase } from '@singularsystems/neo-core';

export default class LogLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    @Attributes.Integer()
    public readonly id: number = 0;

    public readonly message: string = "";

    public readonly level: string = "";

    @Attributes.Date()
    public readonly timeStamp: Date = new Date();

    public readonly exception: string | null = null;

    public readonly source: string | null = null;

    // Client only properties / methods
}